import { uuid } from '../uuid/uuid';

export type SessionId = {
  get: () => string | null;
  set: (id: string) => void;
  clear: () => void;
  getOrCreate: () => string;
};

export const createSessionId = (storageKey: string): SessionId => ({
  get: () => sessionStorage.getItem(storageKey),
  set: (id: string) => {
    sessionStorage.setItem(storageKey, id);
  },
  clear: () => {
    sessionStorage.removeItem(storageKey);
  },
  getOrCreate: () => {
    const existingId = sessionStorage.getItem(storageKey);
    if (existingId) {
      return existingId;
    }

    const newId = uuid();
    sessionStorage.setItem(storageKey, newId);
    return newId;
  },
});
